import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import TYPES from './types';

export interface IRegexSerializer {
    stringify: (regex: RegExp) => string;
    parse: (regex: string) => RegExp;
}

export function injectRegexSerializer(
    container: IContainer = injectOrBuildContainer(),
): IRegexSerializer {
    return container.get<IRegexSerializer>(TYPES.IRegexSerializer);
}

export function bindRegexSerializer(
    val: IRegexSerializer,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IRegexSerializer>(TYPES.IRegexSerializer, val);
}

export function unbindRegexSerializer(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IRegexSerializer);
}
